import { Application } from '@hotwired/stimulus';
import ContentLoader from '@stimulus-components/content-loader';
import RemoteRails from '@stimulus-components/remote-rails';
import TC from "@rolemodel/turbo-confirm"

const application = Application.start();
application.register('content-loader', ContentLoader);
application.register('remote', RemoteRails);

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

TC.start()

export { application };
